import { NgModule, isDevMode , LOCALE_ID } from '@angular/core';
import localeId from '@angular/common/locales/id';
import { registerLocaleData } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';

import { ReactiveFormsModule } from '@angular/forms';
import { NgxCaptchaModule } from 'ngx-captcha';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { NgxPaginationModule } from 'ngx-pagination';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
// import { FooterComponent } from './footer/footer.component';
// import { LayoutComponent } from './shared/layout/layout.component';
// import { PmbtentangkampusComponent } from './pmbtentangkampus/pmbtentangkampus.component';
import { QuillModule } from 'ngx-quill';


// import { UserManagementComponent } from './user-management/user-management.component';
// import { ServiceWorkerModule } from '@angular/service-worker';


import { MAT_DATE_LOCALE } from '@angular/material/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
// import { DateInterceptor } from './shared/interceptors/date.interceptor'
import { CredentialsInterceptor } from './shared/interceptors/credentials.interceptor'

registerLocaleData(localeId);

@NgModule({
  declarations: [
    AppComponent,
    // FooterComponent,
    // LayoutComponent,
    // PmbtentangkampusComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NgxCaptchaModule,
    NgMultiSelectDropDownModule.forRoot(),
    NgxPaginationModule,
    // MatProgressBarModule,
    // QuillModule.forRoot(),
    MatTooltipModule,
    // ServiceWorkerModule.register('ngsw-worker.js', {
    //   enabled: !isDevMode(),
    //   // Register the ServiceWorker as soon as the application is stable
    //   // or after 30 seconds (whichever comes first).
    //   registrationStrategy: 'registerWhenStable:30000'
    // })
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'id-ID' },
    // { provide: MAT_DATE_LOCALE, useValue: 'id-ID' },
    // { provide: HTTP_INTERCEPTORS, useClass: DateInterceptor, multi: true }
    { provide: HTTP_INTERCEPTORS, useClass: CredentialsInterceptor, multi: true }
  ],

  bootstrap: [AppComponent]
})
export class AppModule { }
